const joyrideStyles = {
  spotlight: {
    borderRadius: 20,
  },
};

export default joyrideStyles;
